/**
 * #981: the size a version preview hands its viewer — over the large-CSV threshold the viewer opens
 * the windowed grid instead of reading the whole file into the tab. The version's own size from the
 * versions list; when the list does not hold that version, the file's detail size (the safe
 * direction: a large file's versions open windowed — the grid shows a small one just as well).
 * `undefined` = not known yet (the detail is still loading): the preview waits rather than read a
 * possibly huge file whole.
 */
export function versionPreviewSize(
  versionSize: number | null | undefined,
  detailSize: number | null | undefined,
): number | null | undefined {
  if (typeof versionSize === 'number') return versionSize
  if (detailSize === undefined) return undefined
  return detailSize
}
